<template>
  <div class="form-group" :class="{ 'has-error': hasError }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <currency-input
      class="form-control"
      :value="value"
      :currency="{ prefix: 'R$ ' }"
      locale="pt-br"
      :allow-negative="false"
      :value-range="{ min: 0, max: 100000000 }"
      :distraction-free="{ hideNegligibleDecimalDigits: true, hideCurrencySymbol: false, hideGroupingSymbol: false }"
      v-on="listeners"
      @input="updateValue($event)"
      v-bind="$attrs"
    />
    <span class="help-block" v-if="hasError">{{ errors[0] }}</span>
    <span class="text-warning" v-if="hasWarnings">{{ warnings[0] }}</span>
  </div>
</template>
<script>
import { CurrencyInput } from 'vue-currency-input';

export default {
  components: { CurrencyInput },
  props: {
    value: {
      required: true,
      default: 0,
      validator: prop => typeof prop === 'string' || prop === null || typeof prop === 'number',
    },
    label: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    autofocusEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listeners() {
      const listeners = { ...this.$listeners };

      delete listeners.input;

      return listeners;
    },
    hasError() {
      return this.errors && this.errors.length;
    },
    hasWarnings() {
      return this.warnings && this.warnings.length;
    },
  },
  methods: {
    updateValue($event) {
      this.$emit('input', $event);
    },
  },
};
</script>
